import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { LEAD_SOURCE, APARTMENT_DROPDOWN } from "./type";

export const LeadSource = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    Config.LeadDetails.source
  );
  if (res) {
    const { data } = res;
    dispatch({ type: LEAD_SOURCE, payload: data.response.data });
    return true;
  }
};

export const getApartmentDropDown = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    Config.categoryDetials.appartmentDropDown
  );
  if (res) {
    const { data } = res;
    dispatch({ type: APARTMENT_DROPDOWN, payload: data.response.data });
    return true;
  }
};
